import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    VideoActions,
    VideoActionsContent,
    VideoActionsContentTop,
    VideoLists
} from '../../style/VideoStyle';

import { ReactComponent as PlayVideo } from "../../images/ic_play-button.svg";
import { InputWrapper } from '../inputs/TextInput';
import Modal from "../../components/modal/index";

import { ReactComponent as Edit } from "../../images/ic_edit.svg";
import { ReactComponent as Trash } from "../../images/ic_bin.svg";
import Button from '../button';
import { $apiV1 } from '../../config/api';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useNotification } from '../../components/notification/useNotification';
import { useLexicon } from '../../hooks/useLexicon';
import { NotificationList } from '../notification/NotificationList';
import { trackPlaylistAction } from '../../tracking';
import { formatMatchScore } from '../../helpers/matchScore';
import { PlaylistDownloadModal } from './PlaylistDownloadModal';
import { usePlaylistDownload } from './usePlaylistDownload';

// Date conversion helper function
const convertIsoToYyyyMmDd = (isoDate) => {
    try {
        const dateObject = new Date(isoDate);
        const year = dateObject.getFullYear();
        const month = dateObject.getMonth() + 1;
        const day = dateObject.getDate();
        const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
        return formattedDate;
    } catch (error) {
        return '';
    }
};

// Quick fix: separate checkboxes
const PlaylistCheckbox = styled.input`
    position: absolute;
    right: 20px;
    top: 7vh;

    &[type="checkbox"] {
        appearance: none;
        background-color: transparent;
        margin: 0;
        font: inherit;
        width: 16px;
        height: 16px;
        border: 1px solid ${props => props.theme.green};
        border-radius: 2px;
        transform: translateY(-0.075em);
        display: grid;
        place-content: center;
        cursor: pointer;
    }

    &[type="checkbox"]::before {
        content: "";
        width: 8px;
        height: 0.6em;
        clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 21%, 80% 0, 43% 62%);
        transform: scale(0);
        transition: transform 0.15s ease-in-out;
        background-color: ${props => props.theme.green};
    }

    &[type="checkbox"]:checked::before {
        transform: scale(1);
    }
`;

const ItemCheckbox = styled.input`
  appearance: none;
  background-color: transparent;
  width: 16px;
  height: 16px;
  border: 1px solid ${props => props.theme.green};
  border-radius: 2px;
  display: grid;
  place-content: center;
  cursor: pointer;

  &::before {
    content: '';
    width: 8px;
    height: 0.6em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 21%, 80% 0, 43% 62%);
    transform: scale(0);
    transition: transform 0.15s ease-in-out;
    background-color: ${props => props.theme.green};
  }

  &:checked::before {
    transform: scale(1);
  }
`;

const VideoListItem = ({
                           item,
                           currentVideoIndex,
                           index,
                           handlePlayVideo,
                           parentWidth,
                           handleDeleteVideo,
                           playlist,
                           isAuth,
                           checked,
                           onCheck,
                           stacked,
                       }) => {
    const { t } = useTranslation();
    const [openRenameVideo, setOpenRenameVideo] = useState(false);
    const [openDeleteVideo, setOpenDeleteVideo] = useState(false);
    const [namveVideo, setNameVideo] = useState(item?.title);

    const handleDelete = async (deleteFolderInfo) => {
        try {
            await $apiV1.delete(`/users/playlists/${playlist.id}/${deleteFolderInfo}/`);
            trackPlaylistAction({
              action: 'video_remove',
              entityId: playlist?.id,
              entityLabel: playlist?.title || null,
              metadata: {
                playlist_id: playlist?.id,
                video_id: deleteFolderInfo,
              },
              sourceSurface: 'playlist',
            });
            setOpenDeleteVideo(!openDeleteVideo);
            handleDeleteVideo(deleteFolderInfo)
        } catch (error) {
            console.error("Error fetching match data:", error);
        }
    };

    const handleRenameVideoName = async (id) => {
        try {
            await $apiV1.put(`/users/playlists/${playlist.id}/${id}/`, {
                title: namveVideo
            });
        } catch (error) {
            console.error("Error fetching match data:", error);
        }
    }

    const handleClickRename = (item) => {
        setOpenRenameVideo(!openRenameVideo)
        if (openRenameVideo) {
            handleRenameVideoName(item.id)
        }
    }

    return (
        <VideoLists
            className={currentVideoIndex === index ? 'active' : ''}
            title={item?.title}
            style={{ position: 'relative' }}
        >
            <>
                <div className="videoList" onClick={() => handlePlayVideo(item)}>
                    <PlayVideo />
                    {
                        openRenameVideo
                            ? <InputWrapper>
                                <input
                                    value={namveVideo}
                                    onChange={e => setNameVideo(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && (handleClickRename(item))}
                                />
                            </InputWrapper>
                            : <h3
                                style={{ maxWidth: parentWidth - 66 || 255 }}
                            >
                                {" "}
                                {index + 1}. {namveVideo}
                            </h3>
                    }
                </div>
                {/* Checkbox for selection */}
                {isAuth && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
                        {!stacked && (
                            <>
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleClickRename(item)
                                    }}
                                >
                                    <Edit />
                                </div>
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenDeleteVideo(!openDeleteVideo)
                                    }}
                                >
                                    <Trash />
                                </div>
                            </>
                        )}
                        <div style={{ width: 16, height: 16 }}>
                            <ItemCheckbox
                                type="checkbox"
                                checked={checked}
                                onClick={e => e.stopPropagation()}
                                onChange={e => onCheck(e.target.checked, item)}
                            />
                        </div>
                    </div>
                )}
            </>
            {/* Delete folder */}
            <Modal isOpen={openDeleteVideo} setIsOpen={setOpenDeleteVideo} closeIc>
                <h1>{t("playlist.deleteVideoTitle")}</h1>
                <p style={{ marginBottom: "20px" }}>{t("playlist.deleteVideoDescription")}</p>
                <Button
                    title={t("playlist.deleteFolderButton")}
                    size={"full"}
                    onClick={() => handleDelete(item.id)}
                />
            </Modal>
        </VideoLists>
    )
}

// Match Breaker Component (similar to CheckBoxPanel in EventsPanel)
const MatchBreaker = ({ match, videos, onCheckAllVideosInMatch, checked, maxWidthTitle }) => {
    const matchInfo = match?.details?.match || match?.match;

    if (!matchInfo) return null;

    const matchTitle = `${convertIsoToYyyyMmDd(matchInfo?.date)} ${matchInfo.home_squad?.team?.name || 'Home'} ${formatMatchScore(matchInfo)} ${matchInfo.away_squad?.team?.name || 'Away'}`;

    return (
        <VideoLists
            key={`match-${matchInfo.id || matchInfo.date}`}
            className='video-braker'
            title={matchTitle}
        >
            <>
                <div className="videoList">
                    <h3 style={{ maxWidth: maxWidthTitle }}>
                        {matchTitle}
                    </h3>
                </div>
                <ItemCheckbox
                    type="checkbox"
                    checked={checked}
                    onClick={e => e.stopPropagation()}
                    onChange={e => onCheckAllVideosInMatch(e.target.checked, videos)}
                />
            </>
        </VideoLists>
    );
};

export const VideoListPanel = (props) => {

    const navigate = useNavigate()

    const {
        handlePlayVideo,
        currentVideoIndex,
        playlist,
        stacked = false,
    } = props;
    const parent = useRef(null);

    const [videos, setVideos] = useState([]);
    const [selectedVideos, setSelectedVideos] = useState([]);
    const { notifications, addNotification, removeNotification } = useNotification();
    const playlistDownload = usePlaylistDownload({ addNotification, removeNotification });
    const l  = useLexicon();
    const [showAllDownloadOptions, setShowAllDownloadOptions] = useState(false);

    const isAuth = localStorage.getItem('token');

    useEffect(() => {
        if (playlist?.videos) {
            setVideos(playlist.videos);
            setSelectedVideos([]); // reset selection on playlist change
        }
    }, [playlist])

    const handleDeleteVideo = (video) => {
        const newVideos = [...videos].filter(item => item.id !== video);
        setVideos(newVideos);
        setSelectedVideos(selectedVideos.filter(id => id !== video));
    }

    // Group videos by match
    // Flatten videos with match info helper function (same as MyPlaylist)
    const flattenVideosWithMatchInfo = (videos) => {
        const result = [];
        let currentMatchId = null;

        videos.forEach((video, index) => {
            const matchInfo = video?.details?.match || video?.match;
            const matchId = matchInfo?.id || `${matchInfo?.date}_${matchInfo?.home_team?.name}_${matchInfo?.away_team?.name}`;

            // Add match breaker if this is a new match
            if (matchInfo && matchId !== currentMatchId) {
                if (index === 0) {
                    const nextVideo = videos[index + 1];
                    const nextMatchInfo = nextVideo?.details?.match || nextVideo?.match;
                    const nextMatchId = nextMatchInfo?.id || `${nextMatchInfo?.date}_${nextMatchInfo?.home_team?.name}_${nextMatchInfo?.away_team?.name}`;

                    if (nextMatchId === matchId) {
                        result.push({
                            type: 'match',
                            match: video,
                            matchId: matchId
                        });
                        currentMatchId = matchId;
                    }
                } else {
                    result.push({
                        type: 'match',
                        match: video,
                        matchId: matchId
                    });
                    currentMatchId = matchId;
                }
            }

            // Add the video
            result.push({
                type: 'video',
                video: video,
                matchId: matchId
            });
        });

        return result;
    };

    // Checkbox logic
    const handleCheck = (checked, item) => {
        if (checked) {
            setSelectedVideos(prev => [...prev, item.id]);
        } else {
            setSelectedVideos(prev => prev.filter(id => id !== item.id));
        }
    };

    const handleCheckAll = (checked) => {
        if (checked) {
            setSelectedVideos(videos.map(v => v.id));
        } else {
            setSelectedVideos([]);
        }
    };

    const handleCheckAllVideosInMatch = (checked, matchVideos) => {
        if (checked) {
            const videoIds = matchVideos.map(v => v.id);
            setSelectedVideos(prev => [...new Set([...prev, ...videoIds])]);
        } else {
            const videoIds = matchVideos.map(v => v.id);
            setSelectedVideos(prev => prev.filter(id => !videoIds.includes(id)));
        }
    };

    const allChecked = videos.length > 0 && selectedVideos.length === videos.length;
    const someChecked = selectedVideos.length > 0 && selectedVideos.length < videos.length;

    const handleDownloadCuts = async (data, asOneClip = false) => {
        if (!data || data.length === 0) {
            addNotification('There are no videos available for download', 'error');
            return;
        }

        await playlistDownload.startDownload({
            videos: data,
            mode: asOneClip ? 'video' : 'zip',
            title: playlist?.title || '',
            tracking: {
                entityId: playlist?.id || null,
                entityLabel: playlist?.title || null,
                entityType: playlist?.id ? 'playlist' : 'video',
                sourceSurface: 'playlist',
                downloadMode: asOneClip ? 'single_clip' : 'zip',
            },
        });
        setShowAllDownloadOptions(false); // Reset UI after download
    };

    return (
        <VideoActions ref={parent} $stacked={stacked} $focus={stacked}>

            <VideoActionsContent>
                <h3 className='video-actions-title' style={{width: '100%'}}>
                    {playlist?.title ?? 'Playlist'}
                    {/* Select All Checkbox */}
                    <PlaylistCheckbox
                        type="checkbox"
                        checked={allChecked}
                        onClick={e => e.stopPropagation()}
                        onChange={e => handleCheckAll(e.target.checked)}
                    />
                </h3>
                <VideoActionsContentTop style={{ overflowY: 'auto' }}>
                    {flattenVideosWithMatchInfo(videos).map((item, itemIndex) => {
                        if (item.type === 'match') {
                            const matchVideos = videos.filter(video => {
                                const videoMatchInfo = video?.details?.match || video?.match;
                                const videoMatchId = videoMatchInfo?.id || `${videoMatchInfo?.date}_${videoMatchInfo?.home_team?.name}_${videoMatchInfo?.away_team?.name}`;
                                return videoMatchId === item.matchId;
                            });

                            return (
                                <MatchBreaker
                                    key={`match-${item.matchId}`}
                                    match={item.match}
                                    videos={matchVideos}
                                    onCheckAllVideosInMatch={handleCheckAllVideosInMatch}
                                    checked={matchVideos.every(v => selectedVideos.includes(v.id))}
                                    maxWidthTitle={parent.current?.offsetWidth - 66 || 255}
                                    stacked={stacked}
                                />
                            );
                        } else {
                            const video = item.video;
                            const globalIndex = videos.findIndex(v => v.id === video.id);
                            return (
                                <VideoListItem
                                    key={`video-${video.id}`}
                                    index={globalIndex}
                                    currentVideoIndex={currentVideoIndex}
                                    item={video}
                                    handlePlayVideo={handlePlayVideo}
                                    parentWidth={parent.current?.offsetWidth}
                                    handleDeleteVideo={handleDeleteVideo}
                                    playlist={playlist}
                                    isAuth={isAuth}
                                    checked={selectedVideos.includes(video.id)}
                                    onCheck={handleCheck}
                                    stacked={stacked}
                                />
                            );
                        }
                    })}
                </VideoActionsContentTop>

                {/* Download logic UI */}
                {/* Download logic UI */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '20px 0 0 0',
                        minHeight: 56,   // reserve vertical space
                        minWidth: 430,   // reserve horizontal space
                        alignItems: 'center',
                    }}
                >
                    {/* Single "Show All" button */}
                    {selectedVideos.length === 0 && !showAllDownloadOptions && (
                        <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                            <Button
                                title={l(427)}
                                color="secondary"
                                onClick={() => setShowAllDownloadOptions(true)}
                                disabled={playlistDownload.isBusy}
                                style={{ width: '100%', maxWidth: '430px' }}
                            />
                        </div>
                    )}

                    {/* Two download buttons */}
                    {(selectedVideos.length > 0 || (selectedVideos.length === 0 && showAllDownloadOptions)) && (
                        <div style={{ display: 'flex', gap: 20 }}>
                            <Button
                                title={l(1086)}
                                onClick={() =>
                                    handleDownloadCuts(
                                        selectedVideos.length > 0
                                            ? videos.filter((item) => selectedVideos.includes(item.id))
                                            : videos,
                                        true
                                    )
                                }
                                disabled={playlistDownload.isBusy}
                            />
                            <Button
                                title={l(1087)}
                                color="secondary"
                                onClick={() =>
                                    handleDownloadCuts(
                                        selectedVideos.length > 0
                                            ? videos.filter((item) => selectedVideos.includes(item.id))
                                            : videos,
                                        false
                                    )
                                }
                                disabled={playlistDownload.isBusy}
                            />
                        </div>
                    )}
                </div>


                <br/>
                <Button title="go back" onClick={() =>
                    navigate(
                        `/my-playlists`
                    )
                } style={{margin: "0 20px"}}/>
            </VideoActionsContent>

            <PlaylistDownloadModal
                download={playlistDownload.partsDownload}
                onStop={playlistDownload.stopDownload}
                onResume={playlistDownload.resumeDownload}
                onClose={playlistDownload.closeDownload}
                onPartDownloaded={playlistDownload.markPartDownloaded}
            />

            <NotificationList
                notifications={notifications}
                onClose={removeNotification}
            />

        </VideoActions>
    )
}
